import { createRoute } from '@tanstack/react-router';
import { StartingUniverse } from './index';
import { smartStrategyDefinitionFormRoute } from '@/features/Strategies/strategies.routes';

export const startingUniverseRoute = createRoute({
  getParentRoute: () => smartStrategyDefinitionFormRoute,
  path: 'universe-selection',
  component: StartingUniverse,
});
